// extracted by mini-css-extract-plugin
export default {"stack":"stack-2OdMCO"};